"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const native_1 = require("@react-navigation/native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const theme_1 = require("theme");
const services_1 = require("services");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const MyShoppingCart_1 = require("components/partial/MyShoppingCart");
const Clients_1 = require("components/partial/Clients");
const modal_1 = require("components/modal");
const constants_1 = require("constants/constants");
const QuoteDetail = ({ navigation, route }) => {
    const { id: quoteId, warehouseCode, clientForTransformQuote, } = route.params ?? {};
    const quoteToTranformRef = React.useRef();
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        if (clientForTransformQuote && quoteToTranformRef.current) {
            transformQuote(quoteToTranformRef.current, clientForTransformQuote?.id);
            quoteToTranformRef.current = undefined;
        }
    }, [clientForTransformQuote?.id, warehouseCode]));
    const [modalMessage, setModalMessage] = React.useState("");
    const [isModalMessageOpen, setIsModalMessageOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [quoteDetail, setQuoteDetail] = React.useState();
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        const onSuccess = (response) => {
            setQuoteDetail(response);
        };
        (0, services_1.doQuoteDetail)({
            params: {
                data: {
                    cotid: quoteId,
                },
            },
            callback: {
                onSuccess,
                onLoading: setIsLoading,
            },
        });
    }, [quoteId]));
    const transformQuote = React.useCallback((quote, cliid) => {
        const onSuccess = async (response) => {
            await async_storage_1.default.setItem(constants_1.StorageKey.CLIENT_QUOTE_DATA, JSON.stringify(response.cliente));
            navigation?.navigate(MyShoppingCart_1.name, {
                updateProducts: undefined,
                warehouseCode: warehouseCode,
                quoteClientId: cliid ?? response.cliente?.id,
                quoteId: quoteId,
            });
        };
        const onFail = (msg) => {
            //toast.show({description: msg});
            setModalMessage(msg);
            setIsModalMessageOpen(true);
        };
        (0, services_1.doQuoteTransform)({
            params: {
                data: {
                    cotid: quoteId,
                    cliid: cliid,
                    almacen: warehouseCode,
                },
            },
            callback: {
                onSuccess,
                onFail,
            },
        });
    }, [warehouseCode, quoteId]);
    const onSendToOrderPress = () => {
        if (quoteDetail?.data?.header?.cliid) {
            transformQuote(quoteDetail?.data?.header);
        }
        else {
            quoteToTranformRef.current = quoteDetail?.data?.header;
            navigation.navigate(Clients_1.name, {
                origin: "QuoteDetail",
                quoteId: quoteId,
                quoteWarehouseCode: warehouseCode,
            });
        }
    };
    const renderItem = ({ item }) => (<native_base_1.HStack>
			<native_base_1.Text style={styles.txtProductItem} variant="h4">
				{item.cantidad ?? ""}
			</native_base_1.Text>
			<native_base_1.VStack ml="10">
				<native_base_1.Text style={styles.txtProductItem} variant="h4" mb="0">
					{item.producto ?? ""}
				</native_base_1.Text>
				<native_base_1.Text style={styles.txtProductItem} variant="body5" mt="2">
					{item.codigo ?? ""}
				</native_base_1.Text>
			</native_base_1.VStack>
			<native_base_1.Text style={styles.txtProductItem} variant="body4" flex="1" ml="10" textAlign="end">
				{item.total ?? ""}
			</native_base_1.Text>
		</native_base_1.HStack>);
    return (<>
			<native_base_1.ScrollView style={styles.container}>
				<native_base_1.VStack style={[theme_1.Styles.box, styles.layoutBox]}>
					<native_base_1.HStack alignItems="center">
						<native_base_1.Text style={styles.txtTitle}>Cod. {quoteId}</native_base_1.Text>
						<native_base_1.Button size={{ base: "xs", sm: "xs", md: "sm" }} py="4" borderRadius="30" ml={20} bg={quoteDetail?.data?.header?.estadoColor ??
            "colorVividYellow1"} _hover={{
            bg: quoteDetail?.data?.header
                ?.estadoColorHover ??
                "colorVividYellow1",
        }} _text={{ color: "white" }}>
							{quoteDetail?.data?.header?.estadoText ??
            quoteDetail?.data?.header?.estado ??
            ""}
						</native_base_1.Button>
					</native_base_1.HStack>

					<native_base_1.View style={styles.layoutProductsPrices} flexDir={{
            base: "column",
            lg: "row",
        }}>
						<native_base_1.VStack style={styles.layoutProducts} flex={{
            base: "",
            lg: "1",
        }}>
							<native_base_1.HStack style={styles.layoutDateHour}>
								<native_base_1.VStack style={[styles.layoutDateHoutItem]}>
									<native_base_1.Text style={styles.txtDateHourAddressTitles}>
										{theme_1.Str.date}
									</native_base_1.Text>
									<native_base_1.Text style={[
            styles.txtDateHourAddressValues,
        ]}>
										{quoteDetail?.data?.header?.fecha ?? ""}
									</native_base_1.Text>
								</native_base_1.VStack>
								<native_base_1.VStack style={[styles.layoutDateHoutItem]}>
									<native_base_1.Text style={styles.txtDateHourAddressTitles}>
										{theme_1.Str.hour}
									</native_base_1.Text>
									<native_base_1.Text style={[
            styles.txtDateHourAddressValues,
        ]}>
										{quoteDetail?.data?.header?.hora ?? ""}
									</native_base_1.Text>
								</native_base_1.VStack>
							</native_base_1.HStack>

							<native_base_1.Text style={[
            styles.txtDateHourAddressTitles,
            styles.txtDeliveryAddressTitle,
        ]}>
								{theme_1.Str.client}
							</native_base_1.Text>
							<native_base_1.Text style={[styles.txtDateHourAddressValues]}>
								{quoteDetail?.data?.header?.cliente ?? ""}
							</native_base_1.Text>

							<native_base_1.Text style={styles.txtProducts}>
								{theme_1.Str.products}
							</native_base_1.Text>
							<native_base_1.FlatList data={quoteDetail?.data?.detalle ?? []} renderItem={renderItem}/>
						</native_base_1.VStack>

						<native_base_1.VStack style={styles.layoutPrices} flex={{
            base: "",
            lg: "1",
        }}>
							<native_base_1.HStack style={[styles.layoutPriceTitleValue]}>
								<native_base_1.Text style={[
            styles.txtPriceTitleValue,
            styles.txtPriceTitle,
        ]}>
									{theme_1.Str.subtotal}
								</native_base_1.Text>
								<native_base_1.Text style={[styles.txtPriceTitleValue]}>
									{quoteDetail?.data?.header?.subtotal ?? ""}
								</native_base_1.Text>
							</native_base_1.HStack>
							<native_base_1.HStack style={[
            styles.layoutPriceTitleValue,
            styles.layoutPriceTitleValueDiscount,
        ]}>
								<native_base_1.Text style={[
            styles.txtPriceTitleValue,
            styles.txtPriceTitle,
        ]}>
									{theme_1.Str.igv}
								</native_base_1.Text>
								<native_base_1.Text style={[
            styles.txtPriceTitleValue,
            styles.txtPriceTitle,
        ]}>
									(18%)
								</native_base_1.Text>
								<native_base_1.Text style={[styles.txtPriceTitleValue]}>
									{quoteDetail?.data?.header?.igv ?? ""}
								</native_base_1.Text>
							</native_base_1.HStack>
							<native_base_1.HStack style={[
            styles.layoutPriceTitleValue,
            styles.layoutPriceTitleValueTotal,
        ]}>
								<native_base_1.Text style={[
            styles.txtPriceTitleValue,
            styles.txtPriceTitle,
            styles.txtPriceTitleValueTotal,
        ]}>
									{theme_1.Str.total}
								</native_base_1.Text>
								<native_base_1.Text style={[
            styles.txtPriceTitleValue,
            styles.txtPriceTitleValueTotal,
        ]}>
									{quoteDetail?.data?.header?.total ?? ""}
								</native_base_1.Text>
							</native_base_1.HStack>

							{quoteDetail?.data?.header?.generarPedido && (<native_base_1.Button onPress={onSendToOrderPress} style={styles.btnSend}>
									{theme_1.Str.sendToOrder}
								</native_base_1.Button>)}
						</native_base_1.VStack>
					</native_base_1.View>
				</native_base_1.VStack>
			</native_base_1.ScrollView>
			<FullScreenLoad_1.default isVisible={isLoading}/>
			<modal_1.ModalMessage message={modalMessage} isOpen={isModalMessageOpen}/>
		</>);
};
const styles = react_native_1.StyleSheet.create({
    container: {
        width: "100%",
        padding: 30,
    },
    layoutBox: {
        paddingVertical: 25,
    },
    txtTitle: {
        ...theme_1.TextStyles.body1,
        fontFamily: theme_1.Fonts.bold,
        marginHorizontal: 30,
    },
    layoutProductsPrices: {
        marginTop: 20,
    },
    layoutProducts: {
        marginTop: 20,
        marginHorizontal: 30,
        padding: 20,
        borderRadius: theme_1.Sizes.configRadius,
        borderWidth: 2,
        borderColor: theme_1.Colors.colorLightGray1,
    },
    layoutDateHour: {
        flexDirection: "row",
    },
    layoutDateHoutItem: {
        flex: 1,
    },
    txtDateHourAddressTitles: {
        ...theme_1.TextStyles.body5,
        textTransform: "uppercase",
    },
    txtDateHourAddressValues: {
        marginTop: 5,
        ...theme_1.TextStyles.body2,
    },
    txtDeliveryAddressTitle: {
        marginTop: 20,
    },
    txtProducts: {
        marginTop: 20,
        paddingTop: 20,
        paddingBottom: 10,
        ...theme_1.TextStyles.body2,
        fontFamily: theme_1.Fonts.bold,
        borderTopWidth: 1,
        borderTopColor: theme_1.Colors.colorVeryLightGray3,
    },
    txtProductItem: {
        marginVertical: 10,
    },
    //prices
    layoutPrices: {
        marginTop: 20,
        marginHorizontal: 30,
        alignItems: "center",
    },
    layoutPriceTitleValue: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
    },
    layoutPriceTitleValueDiscount: {
        paddingVertical: 20,
    },
    layoutPriceTitleValueTotal: {
        paddingVertical: 20,
        borderTopColor: "black",
        borderTopWidth: 2,
    },
    txtPriceTitleValue: {
        ...theme_1.TextStyles.body2,
    },
    txtPriceTitle: {
        flex: 1,
    },
    txtPriceTitleValueTotal: {
        fontFamily: theme_1.Fonts.bold,
        textTransform: "uppercase",
    },
    btnSend: {
        marginTop: 20,
    },
});
exports.name = "QuoteDetailName";
exports.default = QuoteDetail;
